

$( document ).on('turbolinks:load', function() {
  if($('body').hasClass('pages-indications')){
    $("#ref_mode").on('change', '', function (e) {
      window.location.replace("/indications?ref_mode=" + $(this).val());
    });
    $("#affiliate_page").on('paste', '', function (e) {
      // Small delay to allow the pasted content to be set in the input
      setTimeout(function() {
        window.location.replace("/indications?affiliate_page=" + $("#affiliate_page").val());
      }, 100);
    });
  }
})
